export class MultiColumnBlock {
    private window: any = window;
    private columns: JQuery;
    private readonly desktopBreakpoint = 530;

    constructor() {
        this.columns = $(".multi-column-block .col");
        
        this.init();
        //get first tab as default
    }
    private init() {
        if (this.window.Helpers.mobilecheck()) {
            $('body').click((e) => {
                let $target = $(e.target);

                this.columns.each((i, el) => {
                    let $el = $(el);

                    if (!$target.is($el) && !$target.closest($el).length) {
                        $el.removeClass("active");
                    }
                })
            });

            this.columns.click(e => {
                e.preventDefault();
                $(e.currentTarget).addClass("active");
            });
        }
    }
}

